import { Component, OnInit, Input } from '@angular/core';
import { AuthService } from '../auth.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-toolbar',
  templateUrl: './toolbar.component.html',
  styleUrls: ['./toolbar.component.css']
})
export class ToolbarComponent implements OnInit {
  @Input('logged-in') loggedIn: boolean = false;

  constructor(private authService: AuthService,
              private router: Router) { }

  ngOnInit() {
  }

  logout(){
    this.authService.logout();
  }
  navigateTo(link)
  {
    this.router.navigate([link]);
  }
}


// WEBPACK FOOTER //
// ./src/app/toolbar/toolbar.component.ts